export interface NormalizedApiError {
  status?: number;
  response?: unknown;
  result?: unknown;
  message?: string;
}

export function normalizeApiError(error: unknown): NormalizedApiError {
  const e = (error ?? {}) as {
    status?: number;
    response?: {status?: number} | unknown;
    result?: unknown;
    message?: string;
  };

  return {
    status: e.status ?? (e.response as {status?: number} | undefined)?.status,
    response: e.response,
    result: e.result,
    message: e.message ?? 'Unexpected Server Error was encountered.',
  };
}
